export default __webpack_public_path__ + "static/media/monitor.03a0ee5b.svg";